import url from 'libraries/front-end-core/core/url'
import { Controller } from 'libraries/front-end-core/core/Router'
import { replaceUrl } from 'libraries/front-end-core/core/history'
import { LEGISLATION_MENU } from 'constants/controllers'

export default new Controller({
  name: 'LegacyLegislationAllRedirect',
  route: ':aol/legislation/all',
  controller (Router) {
    const target = url(LEGISLATION_MENU)
    replaceUrl(target)
  }
})
